import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  GetDeviceEventsQueryParams,
  GetDeviceEventsResponse,
} from './deviceEvents.types';
import { getDeviceEventsAPI } from './deviceEvents.api';

export const getDeviceEventsAction = createAsyncThunkFromFetch<
  GetDeviceEventsResponse,
  {
    params: GetDeviceEventsQueryParams;
  }
>('device-events', getDeviceEventsAPI);
